import Activity from "../../interfaces/activity"

const ActivityData: Activity[] = [
    {
        name: 'Skiing',
        attractions: [
            { name: 'Ragged Mountain', link: 'www.raggedmountainresort.com' },
            { name: 'Mount Sunapee', link: 'www.mountsunapee.com' },
            { name: 'Gunstock Mountain', link: 'www.gunstock.com' },
            { name: 'Loon Mountain', link: 'www.loonmtn.com' },
            { name: 'Waterville Valley', link: 'www.waterville.com' },
            { name: 'Cannon Mountain', link: 'www.cannonmt.com' },
            { name: 'Bretton Woods', link: 'www.OnTheSnow.com' }
        ]
    },
    {
        name: 'Snowmobiling',
        attractions: [
            { name: 'Northern Extremes', 'link': 'www.northernextremessnowmobiling.com' },
            { name: 'Alpine Adventures', 'link': 'www.alpinezipline.com' },
            { name: 'Trail Side Rentals', 'link': 'www.trailsiderentals.com' },
            { name: 'Snowmobile Directory', 'link': 'www.directorynh.com/NHRecreation-Attractions/NHSnowmobiling.html' }
        ]
    },
    {
        name: 'Golfing ',
        attractions: [
            { name: 'Ragged Mountain Golf Course', 'link': 'www.raggedmountainresort.com' },
            { name: 'Owl\'s Nest Golf', 'link': 'www.owlsnestgolf.com' },
            { name: 'Pheasant Ridge Gold Club', 'link': 'www.playgolfne.com' },
            { name: 'White Mountain Country Club', 'link': '	www.playgolfne.com' },
            { name: 'Lochmere Golf & Country Club', 'link': 'www.lochmeregolf.com' },
            { name: 'Oak Hill Golf Club', 'link': 'www.oakhillgc.com' },
            { name: 'Waukewan Golf Club', 'link': 'www.waukewan.com' },
            { name: 'White Mountain Country Club', 'link': 'www.playgolfne.com' }
        ]
    },
    {
        name: 'Miniature Golf',
        attractions: [
            { name: 'Pirate\'s Cove Mini Golf', 'link': 'www.raggedmountainresort.com' },
            { name: 'Mount Sunapee', 'link': 'www.mountsunapee.com' }
        ]
    },
    {
        name: 'Railroads',
        attractions: [
            { name: 'Conway Scenic Railroad', 'link': 'www.conwayscenic.com' },
            { name: 'Mt. Washington Cog Railway', 'link': 'www.thecog.com' },
            { name: 'Winnipesaukee Scenic Railroad', 'link': 'www.HoboRR.co' }
        ],
    },
    {
        name: 'Boating, Canoeing, Kayaking',
        attractions: [
            { name: 'Saco Valley Canoe', 'link': 'www.sacocanoe.com' },
            { name: 'Saco Bound', 'link': 'www.sacobound.com' },
            { name: 'Winnipesaukee Cruise', 'link': 'www.cruiseNH.com' }
        ]
    },
    {
        name: 'Swimming & Water Parks',
        attractions: [
            { name: 'Weir\'s Beach & Water Slide', 'link': 'www.wiersbeach.net' },
            { name: 'Whales Tale Water Park', 'link': 'www.whalestalewaterpark.net' },
            { name: 'Wellington State Park', 'link': 'www.nhstateparks.com/wellington.html' }
        ]
    },
    {
        name: 'Hiking & Walking Trails',
        attractions: [
            { name: 'Lost River Gorge & Caves', 'link': 'www.lostrivergorge.com' },
            { name: 'Franconia Notch State Park', 'link': 'www.flumegorge.com' }
        ]
    },
    {
        name: 'Museums',
        attractions: [
            { name: 'Canterbury Shaker Village', 'link': 'www.shakers.org' },
            { name: 'Castle in the Clouds', 'link': 'www.castleintheclouds.org' },
            { name: 'America\'s Stonehenge', 'link': 'www.stonehengeusa.com' },
            { name: 'The Loon Center', 'link': 'www.loon.org' },
            { name: 'Mt. Kearsarge Indian Museum', 'link': 'www.indianmuseum.org' },
            { name: 'Charmingfare Farm (ZOO)', 'link': 'www.VisitTheFarm.com' },
            { name: 'Squam Lake Natural Science Center', 'link': 'www.nhnature.org' }
        ]
    },
    {
        name: 'Dining',
        attractions: [
            { name: 'The Homestead', 'link': 'www.homesteadnh.com' },
            { name: 'Fratello\'s', 'link': 'www.fratellos.com' },
            { name: 'Hart\'s Turkey Farm', 'link': 'www.hartsturkeyfarm.com' }
        ]
    },
    {
        name: 'Shopping',
        attractions: [
            { name: 'Tanger Outlet Shopping', 'link': 'www.tangeroutlet.com' },
            { name: 'Mill Falls Marketplace', 'link': 'www.millfalls.com' },
            { name: 'Annalee Doll Outlet Store', 'link': 'www.annaleeoutlet.com' },
            { name: 'The Christmas Loft', 'link': 'www.christmasloft.com' }
        ]
    },
    {
        name: 'Family and Children\'s Activities:',
        attractions: [
            { name: 'Polar Caves', 'link': 'www.polarcaves.com' },
            { name: 'Ruggles Mine', 'link': 'www.rugglesmine.com' },
            { name: 'Clark\'s Trading Post', 'link': 'www.clarkstradingpost.com' },
            { name: 'Whale\'s Tale Water Park', 'link': 'www.getsettogetwet.com' },
            { name: 'Sant\'s Village', 'link': 'www.santasvillage.com' },
            { name: 'Six Gun City & Fort Splash', 'link': 'www.sixguncity.com' },
            { name: 'Logs of Fun Arcade', 'link': 'www.logs-of-fun.com' },
            { name: 'Daytona Fun Park', 'link': 'www.thedaytonafunpark.com' },
            { name: 'Story Land', 'link': 'www.storylandnh.com' },
            { name: 'Alpine Adventures', 'link': 'www.alpinezipline.com' },
            { name: 'The Fun Spot', 'link': 'www.FunspotNH.com' },
        ]
    }
]

export default ActivityData
